var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 258,
    viewBox: "0 0 268 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.971 68.2619L265.87 36.9108L258.931 29.6289L226.031 60.98L232.971 68.2619Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.172 130.965L200.072 99.6133L193.132 92.3313L160.233 123.683L167.172 130.965Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.207 53.8186L252.106 22.4675L245.167 15.1855L212.268 46.5366L219.207 53.8186Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.408 116.521L186.307 85.17L179.368 77.888L146.469 109.239L153.408 116.521Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.19 92.3918L226.089 61.0407L219.149 53.7588L186.25 85.1099L193.19 92.3918Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.174 193.858L134.073 162.507L127.133 155.225L94.2344 186.576L101.174 193.858Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4098 179.414L120.309 148.063L113.369 140.781L80.4705 172.132L87.4098 179.414Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.391 155.094L160.29 123.743L153.351 116.461L120.452 147.812L127.391 155.094Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3751 256.56L68.2743 225.209L61.335 217.927L28.4358 249.278L35.3751 256.56Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6112 242.116L54.5104 210.765L47.5711 203.483L14.6719 234.834L21.6112 242.116Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1917 218.178L94.0909 186.827L87.1516 179.545L54.2524 210.896L61.1917 218.178Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.252 39.1745L238.151 7.82344L231.212 0.541489L198.312 31.8926L205.252 39.1745Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.453 101.877L172.353 70.5259L165.413 63.2439L132.514 94.5952L139.453 101.877Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.234 77.7473L212.134 46.3962L205.194 39.1142L172.295 70.4653L179.234 77.7473Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4547 164.77L106.354 133.419L99.4144 126.137L66.5154 157.488L73.4547 164.77Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.436 140.45L146.335 109.099L139.396 101.817L106.497 133.168L113.436 140.45Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65609 227.472L40.5553 196.121L33.616 188.839L0.716797 220.19L7.65609 227.472Z",
    fill: "#FA5901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2367 203.534L80.1358 172.183L73.1965 164.901L40.2974 196.252L47.2367 203.534Z",
    fill: "#FA5901"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_1924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 318.669,
    height: 52.6497,
    fill: "white",
    transform: "translate(0 219.84) rotate(-43.6197)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/Track.717df4b0dded9873ee91b40a4ae5c7d2.svg";
export { ForwardRef as ReactComponent };